import { Link } from "react-router-dom";
import { HERO_BG } from "@/lib/api";
import { BrandLogo } from "@/components/BrandLogo";

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-brand-ink text-white/70 mt-28">
      {/* Molecular string background (matches hero) */}
      <img src={HERO_BG} alt="" aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-72 w-full object-cover opacity-30" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-brand-ink/70 via-brand-ink to-brand-ink" />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-8 py-20">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="relative inline-block">
              <span aria-hidden="true" className="absolute left-1/2 top-1/2 h-28 w-72 -translate-x-1/2 -translate-y-1/2 rounded-[50%] bg-white blur-2xl opacity-95" />
              <BrandLogo h={92} className="relative" />
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed">
              High-purity, domestic-origin research peptides with fast U.S. shipping. Total performance, backed by science.
            </p>
          </div>
          <div>
            <h4 className="font-mono-label text-xs uppercase tracking-[0.2em] text-brand-teal">Explore</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/shop" className="hover:text-white transition-colors">Shop Peptides</Link></li>
              <li><Link to="/telehealth" className="hover:text-white transition-colors">Telehealth Intake</Link></li>
              <li><Link to="/training" className="hover:text-white transition-colors">Training Coaching</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono-label text-xs uppercase tracking-[0.2em] text-brand-teal">Account</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/auth" className="hover:text-white transition-colors">Sign In / Register</Link></li>
              <li><Link to="/account" className="hover:text-white transition-colors">My Orders</Link></li>
              <li><Link to="/admin" className="hover:text-white transition-colors">Admin</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8">
          <p className="font-mono-label text-[11px] uppercase tracking-[0.15em] text-white/40 leading-relaxed">
            For research use only. Not for human consumption. All products are sold as research chemicals and are not
            intended to diagnose, treat, cure, or prevent any disease. Buyers must be qualified researchers and comply
            with all applicable laws.
          </p>
          <p className="mt-6 text-xs text-white/40">
            © {new Date().getFullYear()} Just Peptides Supply. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
